import {
  RELATIONSHIP_TYPES,
  SEAT_PREFERENCES,
  type MeasurementSystem,
  type RelatedPassengerFormData,
} from '@/types/clientsApiTypes';

export const MAILING_FIELDS = [
  'client_mailing_address',
  'client_mailing_address_line_2',
  'client_mailing_city',
  'client_mailing_state',
  'client_mailing_country',
  'zip_code',
] as const;
export const BILLING_FIELDS = [
  'client_billing_address',
  'client_billing_address_line_2',
  'client_billing_city',
  'client_billing_state',
  'client_billing_country',
  'billing_zip_code',
] as const;
export const MAILING_TO_BILLING_MAP = {
  client_mailing_address: 'client_billing_address',
  client_mailing_address_line_2: 'client_billing_address_line_2',
  client_mailing_city: 'client_billing_city',
  client_mailing_state: 'client_billing_state',
  client_mailing_country: 'client_billing_country',
  zip_code: 'billing_zip_code',
} as const;
export const RELATED_PASSENGER_EMPTY_VALUES: RelatedPassengerFormData = {
  client: {
    client_id: 0,
    userHasCertifiedTheInformation: false,
    preferred_name: null,
    first_name: '',
    middle_name: null,
    last_name: '',
    gender: '',
    relationship: RELATIONSHIP_TYPES.sibling,
    contact_primary_client_id: null,
    date_of_birth: '',
    email: '',
    phone: '',
    additional_emails: [],
    phones: [],
    client_mailing_address: '',
    client_mailing_address_line_2: '',
    client_mailing_city: '',
    client_mailing_state: '',
    client_mailing_country: '',
    zip_code: '',
    same_as_primary: false,
  },
  tsa: {
    global_entry: null,
    global_expiry_date: null,
    known_traveler_number: null,
    known_traveler_number_expire_date: null,
  },
  passport: {
    passport_number: null,
    expiry_date: null,
    passport_id: null,
  },
  preference_data: {
    allergies: null,
    fly: {
      seat: SEAT_PREFERENCES.window,
      allergies: '',
      preferred_private_aviation_company: null,
      fly_private_aviation: 'no',
      class_preference: [],
    },
    personal: {
      personal_metric_system: 'us' as MeasurementSystem,
      comfort_related: {
        us: {
          height: '',
          weight: '',
        },
        metric: {
          height: '',
          weight: '',
        },
      },
      information: '',
    },
  },
  documents: [],
  loyalty_numbers: [],
};
